"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InterestingBut = exports.InterestingBottom = exports.InterestingDesc = exports.InterestingT = exports.InterestingTop = exports.InterestingEl = exports.InterestingTitle = exports.InterestingListContainer = exports.InterestingListWrapper = void 0;

var _constants = require("../../../assets/js/constants");

var _styledButton = _interopRequireDefault(require("../../buttons/styledButton"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InterestingListWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled__InterestingListWrapper",
  componentId: "sc-1xhvwk0-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    overflow: hidden;\n    padding-bottom: 40px;\n    background: ", ";\n    @media (max-width: 1500px) {\n        margin-top: 20px;\n    }\n"])), _constants.COLORS.lightGrey);

exports.InterestingListWrapper = InterestingListWrapper;

var InterestingListContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__InterestingListContainer",
  componentId: "sc-1xhvwk0-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100%;\n    overflow: visible;\n    margin: 0 auto;\n    @media(max-width: 640px) {\n        max-width: 370px;\n        margin: 0;\n        position: relative;\n    }\n"])));

exports.InterestingListContainer = InterestingListContainer;

var InterestingTitle = _styledComponents["default"].div.withConfig({
  displayName: "styled__InterestingTitle",
  componentId: "sc-1xhvwk0-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    font-size: 32px;\n    line-height: 40px;\n    margin-bottom: 18px;\n    margin-top: 30px;\n    @media (max-width: 1500px) {\n        font-size: 24px;\n        line-height: 32px;\n        margin-bottom: 15px;\n        margin-top: 10px;\n    }\n    @media (max-width: 600px) {\n        font-size: 20px;\n        line-height: 28px;\n    }\n"])));

exports.InterestingTitle = InterestingTitle;

var InterestingEl = _styledComponents["default"].div.withConfig({
  displayName: "styled__InterestingEl",
  componentId: "sc-1xhvwk0-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: block;\n    flex-direction: column;\n    margin: 10px 5px;\n    border-radius: 8px;\n    background: ", ";\n    border: 1px solid ", ";\n    width: 100%;\n    :hover {\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.09);\n    };\n    @media (max-width: 1500px) {\n        margin: 10px 5px\n    }\n"])), _constants.COLORS.white, _constants.COLORS.outlineGrey);

exports.InterestingEl = InterestingEl;

var InterestingTop = _styledComponents["default"].div.withConfig({
  displayName: "styled__InterestingTop",
  componentId: "sc-1xhvwk0-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    background: ", ";\n    background-repeat: round;\n    border-radius: 8px 8px 0 0;\n    padding: 25px;\n    min-height: 167px;\n    justify-content: flex-start;\n    font-family: 'robotoregular';\n"])), function (props) {
  return props.back;
});

exports.InterestingTop = InterestingTop;

var InterestingT = _styledComponents["default"].div.withConfig({
  displayName: "styled__InterestingT",
  componentId: "sc-1xhvwk0-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: flex;\n    width: 100%;\n    font-size: 14px;\n    line-height: 18px;\n    color: ", ";\n    margin-bottom: 15px;\n"])), _constants.COLORS.white);

exports.InterestingT = InterestingT;

var InterestingDesc = _styledComponents["default"].div.withConfig({
  displayName: "styled__InterestingDesc",
  componentId: "sc-1xhvwk0-6"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: flex;\n    white-space: pre-wrap;\n    width: 100%;\n    font-size: 20px;\n    line-height: 28px;\n    color: ", ";\n    @media (max-width: 1300px) {\n        font-size: 16px;\n        line-height: 24px;\n    }\n"])), _constants.COLORS.white);

exports.InterestingDesc = InterestingDesc;

var InterestingBottom = _styledComponents["default"].div.withConfig({
  displayName: "styled__InterestingBottom",
  componentId: "sc-1xhvwk0-7"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    display: flex;\n    padding: 30px 25px 30px;\n"])));

exports.InterestingBottom = InterestingBottom;
var InterestingBut = (0, _styledComponents["default"])(_styledButton["default"]).withConfig({
  displayName: "styled__InterestingBut",
  componentId: "sc-1xhvwk0-8"
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    display: block;\n    font-size: 14px;\n    line-height: 18px;\n    height: 42px;\n    padding: 10px 20px;\n    width: auto;\n    @media (max-width: 1300px) {\n        width: 100%;\n        padding: 10px 0;\n        text-align: center;\n    }\n"])));
exports.InterestingBut = InterestingBut;